import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/core/services/login.service';

@Injectable()
export class OnlyLoggedInUsersGuard  {
    constructor(
        private loginSvc: LoginService,
        private route: Router
    ) { }

    canActivate() {
        // let isLoggerIn;
        // this.loginSvc.currentMessage.subscribe((loginStatus) => {
        //     isLoggerIn = loginStatus;
        // });

        // if (!isLoggerIn) {
        //     this.route.navigate(['/login'], { replaceUrl: true });
        //     return isLoggerIn;
        // } else {
        //     return isLoggerIn;
        // }

        if (localStorage.getItem('loggedInUserData') && localStorage.getItem('refreshToken')) {
            return true;
        } else {
            this.route.navigate(['/login'], { replaceUrl: true });
            return false;
        }

    }
}
